// Generated by Melange

import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const Buhta = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_etp_link.ml",
      138,
      6
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  /* Function */0,
                                  "make"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto"
                                ],
                                [
                                  /* Function */0,
                                  "to_json"
                                ],
                                [
                                  /* Function */0,
                                  "from_json"
                                ],
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "merge"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto$p"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto_exn"
                                ],
                                [
                                  /* Function */0,
                                  "from_json_exn"
                                ]
                              ]
                            },
                            "EtpDetails"
                          ],
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "EtpInfo"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "EtpLink"
                    ]
                  ]
                },
                "V1alpha1"
              ]]
          },
          "Kassa"
        ]]
    });

const Kassa = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_etp_link.ml",
      241,
      8
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "EtpDetails"
                    ],
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "EtpInfo"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "EtpLink"
              ]
            ]
          },
          "V1alpha1"
        ]]
    });

const V1alpha1 = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_etp_link.ml",
      342,
      10
    ], {
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "EtpDetails"
              ],
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "EtpInfo"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "EtpLink"
        ]
      ]
    });

const EtpInfo = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_etp_link.ml",
      409,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "EtpDetails"
        ],
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const EtpLink = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_etp_link.ml",
      556,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const EtpDetails = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_etp_link.ml",
      444,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.kassa.v1alpha1.EtpInfo.EtpDetails";
}

function make(show_headerOpt, logo_url, support_email, support_phone, support_url, param) {
  const show_header = show_headerOpt !== undefined ? show_headerOpt : false;
  return {
          show_header: show_header,
          logo_url: logo_url,
          support_email: support_email,
          support_phone: support_phone,
          support_url: support_url
        };
}

const merge_show_header = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "show_header",
            "showHeader"
          ],
          Ocaml_protoc_plugin__Spec.bool,
          false
        ]));

const merge_logo_url = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            2,
            "logo_url",
            "logoUrl"
          ],
          Ocaml_protoc_plugin__Spec.string
        ]));

const merge_support_email = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            3,
            "support_email",
            "supportEmail"
          ],
          Ocaml_protoc_plugin__Spec.string
        ]));

const merge_support_phone = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            4,
            "support_phone",
            "supportPhone"
          ],
          Ocaml_protoc_plugin__Spec.string
        ]));

const merge_support_url = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            5,
            "support_url",
            "supportUrl"
          ],
          Ocaml_protoc_plugin__Spec.string
        ]));

function merge(t1, t2) {
  return {
          show_header: Curry._2(merge_show_header, t1.show_header, t2.show_header),
          logo_url: Curry._2(merge_logo_url, t1.logo_url, t2.logo_url),
          support_email: Curry._2(merge_support_email, t1.support_email, t2.support_email),
          support_phone: Curry._2(merge_support_phone, t1.support_phone, t2.support_phone),
          support_url: Curry._2(merge_support_url, t1.support_url, t2.support_url)
        };
}

function spec(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "show_header",
                    "showHeader"
                  ],
                  Ocaml_protoc_plugin__Spec.bool,
                  false
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                      [
                        2,
                        "logo_url",
                        "logoUrl"
                      ],
                      Ocaml_protoc_plugin__Spec.string
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                          [
                            3,
                            "support_email",
                            "supportEmail"
                          ],
                          Ocaml_protoc_plugin__Spec.string
                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                              [
                                4,
                                "support_phone",
                                "supportPhone"
                              ],
                              Ocaml_protoc_plugin__Spec.string
                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                  [
                                    5,
                                    "support_url",
                                    "supportUrl"
                                  ],
                                  Ocaml_protoc_plugin__Spec.string
                                ]), Ocaml_protoc_plugin__Spec.nil)))));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
    });

function to_proto$p(writer, param) {
  Curry._6(serialize, writer, param.show_header, param.logo_url, param.support_email, param.support_phone, param.support_url);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(show_header, logo_url, support_email, support_phone, support_url) {
  return {
          show_header: show_header,
          logo_url: logo_url,
          support_email: support_email,
          support_phone: support_phone,
          support_url: support_url
        };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
    });

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn, writer);
            });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.EtpInfo.EtpDetails", spec(undefined))(options);
  return function (param) {
    return Curry._5(serialize, param.show_header, param.logo_url, param.support_email, param.support_phone, param.support_url);
  };
}

function constructor$1(show_header, logo_url, support_email, support_phone, support_url) {
  return {
          show_header: show_header,
          logo_url: logo_url,
          support_email: support_email,
          support_phone: support_phone,
          support_url: support_url
        };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.EtpInfo.EtpDetails", spec(undefined), constructor$1);
    });

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, EtpDetails, {
      make: make,
      to_proto: to_proto,
      from_proto: from_proto,
      to_json: to_json,
      from_json: from_json,
      name: name,
      merge: merge,
      to_proto$p: to_proto$p,
      from_proto_exn: from_proto_exn,
      from_json_exn: from_json_exn
    });

function name$1(param) {
  return ".buhta.kassa.v1alpha1.EtpInfo";
}

function make$1(idOpt, keyOpt, nameOpt, details, param) {
  const id = idOpt !== undefined ? idOpt : 0;
  const key = keyOpt !== undefined ? keyOpt : "";
  const name = nameOpt !== undefined ? nameOpt : "";
  return {
          id: id,
          key: key,
          name: name,
          details: details
        };
}

const merge_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "id",
            "id"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

const merge_key = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "key",
            "key"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            3,
            "name",
            "name"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_details = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            4,
            "details",
            "details"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: EtpDetails.name,
                make: EtpDetails.make,
                from_proto: EtpDetails.from_proto,
                from_proto_exn: EtpDetails.from_proto_exn,
                to_proto: EtpDetails.to_proto,
                to_proto$p: EtpDetails.to_proto$p,
                merge: EtpDetails.merge,
                to_json: EtpDetails.to_json,
                from_json_exn: EtpDetails.from_json_exn,
                from_json: EtpDetails.from_json
              })
        ]));

function merge$1(t1, t2) {
  return {
          id: Curry._2(merge_id, t1.id, t2.id),
          key: Curry._2(merge_key, t1.key, t2.key),
          name: Curry._2(merge_name, t1.name, t2.name),
          details: Curry._2(merge_details, t1.details, t2.details)
        };
}

function spec$1(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "id",
                    "id"
                  ],
                  Ocaml_protoc_plugin__Spec.int32_int,
                  0
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "key",
                        "key"
                      ],
                      Ocaml_protoc_plugin__Spec.string,
                      ""
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                          [
                            3,
                            "name",
                            "name"
                          ],
                          Ocaml_protoc_plugin__Spec.string,
                          ""
                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                              [
                                4,
                                "details",
                                "details"
                              ],
                              Ocaml_protoc_plugin__Spec.message({
                                    name: EtpDetails.name,
                                    make: EtpDetails.make,
                                    from_proto: EtpDetails.from_proto,
                                    from_proto_exn: EtpDetails.from_proto_exn,
                                    to_proto: EtpDetails.to_proto,
                                    to_proto$p: EtpDetails.to_proto$p,
                                    merge: EtpDetails.merge,
                                    to_json: EtpDetails.to_json,
                                    from_json_exn: EtpDetails.from_json_exn,
                                    from_json: EtpDetails.from_json
                                  })
                            ]), Ocaml_protoc_plugin__Spec.nil))));
}

const serialize$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$1(undefined));
    });

function to_proto$p$1(writer, param) {
  Curry._5(serialize$1, writer, param.id, param.key, param.name, param.details);
}

function to_proto$1(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$1(writer, t);
  return writer;
}

function constructor$2(id, key, name, details) {
  return {
          id: id,
          key: key,
          name: name,
          details: details
        };
}

const from_proto_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$1(undefined), constructor$2);
    });

function from_proto$1(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$1, writer);
            });
}

function to_json$1(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.EtpInfo", spec$1(undefined))(options);
  return function (param) {
    return Curry._4(serialize, param.id, param.key, param.name, param.details);
  };
}

function constructor$3(id, key, name, details) {
  return {
          id: id,
          key: key,
          name: name,
          details: details
        };
}

const from_json_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.EtpInfo", spec$1(undefined), constructor$3);
    });

function from_json$1(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$1, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "EtpDetails"
        ],
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, EtpInfo, {
      EtpDetails: EtpDetails,
      make: make$1,
      to_proto: to_proto$1,
      from_proto: from_proto$1,
      to_json: to_json$1,
      from_json: from_json$1,
      name: name$1,
      merge: merge$1,
      to_proto$p: to_proto$p$1,
      from_proto_exn: from_proto_exn$1,
      from_json_exn: from_json_exn$1
    });

function name$2(param) {
  return ".buhta.kassa.v1alpha1.EtpLink";
}

function make$2(info, allow_ingressOpt, allow_egressOpt, param) {
  const allow_ingress = allow_ingressOpt !== undefined ? allow_ingressOpt : false;
  const allow_egress = allow_egressOpt !== undefined ? allow_egressOpt : false;
  return {
          info: info,
          allow_ingress: allow_ingress,
          allow_egress: allow_egress
        };
}

const merge_info = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "info",
            "info"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: EtpInfo.name,
                make: EtpInfo.make,
                from_proto: EtpInfo.from_proto,
                from_proto_exn: EtpInfo.from_proto_exn,
                to_proto: EtpInfo.to_proto,
                to_proto$p: EtpInfo.to_proto$p,
                merge: EtpInfo.merge,
                to_json: EtpInfo.to_json,
                from_json_exn: EtpInfo.from_json_exn,
                from_json: EtpInfo.from_json
              })
        ]));

const merge_allow_ingress = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "allow_ingress",
            "allowIngress"
          ],
          Ocaml_protoc_plugin__Spec.bool,
          false
        ]));

const merge_allow_egress = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            3,
            "allow_egress",
            "allowEgress"
          ],
          Ocaml_protoc_plugin__Spec.bool,
          false
        ]));

function merge$2(t1, t2) {
  return {
          info: Curry._2(merge_info, t1.info, t2.info),
          allow_ingress: Curry._2(merge_allow_ingress, t1.allow_ingress, t2.allow_ingress),
          allow_egress: Curry._2(merge_allow_egress, t1.allow_egress, t2.allow_egress)
        };
}

function spec$2(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "info",
                    "info"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: EtpInfo.name,
                        make: EtpInfo.make,
                        from_proto: EtpInfo.from_proto,
                        from_proto_exn: EtpInfo.from_proto_exn,
                        to_proto: EtpInfo.to_proto,
                        to_proto$p: EtpInfo.to_proto$p,
                        merge: EtpInfo.merge,
                        to_json: EtpInfo.to_json,
                        from_json_exn: EtpInfo.from_json_exn,
                        from_json: EtpInfo.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "allow_ingress",
                        "allowIngress"
                      ],
                      Ocaml_protoc_plugin__Spec.bool,
                      false
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                          [
                            3,
                            "allow_egress",
                            "allowEgress"
                          ],
                          Ocaml_protoc_plugin__Spec.bool,
                          false
                        ]), Ocaml_protoc_plugin__Spec.nil)));
}

const serialize$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$2(undefined));
    });

function to_proto$p$2(writer, param) {
  Curry._4(serialize$2, writer, param.info, param.allow_ingress, param.allow_egress);
}

function to_proto$2(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$2(writer, t);
  return writer;
}

function constructor$4(info, allow_ingress, allow_egress) {
  return {
          info: info,
          allow_ingress: allow_ingress,
          allow_egress: allow_egress
        };
}

const from_proto_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$2(undefined), constructor$4);
    });

function from_proto$2(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$2, writer);
            });
}

function to_json$2(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.EtpLink", spec$2(undefined))(options);
  return function (param) {
    return Curry._3(serialize, param.info, param.allow_ingress, param.allow_egress);
  };
}

function constructor$5(info, allow_ingress, allow_egress) {
  return {
          info: info,
          allow_ingress: allow_ingress,
          allow_egress: allow_egress
        };
}

const from_json_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.EtpLink", spec$2(undefined), constructor$5);
    });

function from_json$2(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$2, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, EtpLink, {
      make: make$2,
      to_proto: to_proto$2,
      from_proto: from_proto$2,
      to_json: to_json$2,
      from_json: from_json$2,
      name: name$2,
      merge: merge$2,
      to_proto$p: to_proto$p$2,
      from_proto_exn: from_proto_exn$2,
      from_json_exn: from_json_exn$2
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "EtpDetails"
              ],
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "EtpInfo"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "EtpLink"
        ]
      ]
    }, V1alpha1, {
      EtpInfo: EtpInfo,
      EtpLink: EtpLink
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "EtpDetails"
                    ],
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "EtpInfo"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "EtpLink"
              ]
            ]
          },
          "V1alpha1"
        ]]
    }, Kassa, {
      V1alpha1: V1alpha1
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  /* Function */0,
                                  "make"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto"
                                ],
                                [
                                  /* Function */0,
                                  "to_json"
                                ],
                                [
                                  /* Function */0,
                                  "from_json"
                                ],
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "merge"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto$p"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto_exn"
                                ],
                                [
                                  /* Function */0,
                                  "from_json_exn"
                                ]
                              ]
                            },
                            "EtpDetails"
                          ],
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "EtpInfo"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "EtpLink"
                    ]
                  ]
                },
                "V1alpha1"
              ]]
          },
          "Kassa"
        ]]
    }, Buhta, {
      Kassa: Kassa
    });

export {
  Imported$pmodules ,
  Buhta ,
}
/* Buhta Not a pure module */
